<template>
    <div class="filter-wrap">
        <div class="filter-list width-scroll">
            <div class="filter" v-if="selectType">{{selectType.name}}</div>
            <div class="filter" v-if="selectEvent">{{selectEvent.name}}</div>
            <div class="filter" v-if="selectAge">{{selectAge.ageCode}}</div>
            <div class="filter" v-if="selectLevel">{{selectLevel.levelCode}}</div>
        </div>
        <div class="filter-btn" @click="filterFunc"><p>필터</p></div>

        <DefaultTournamentFilter v-show="filterShow" :show="filterShow" @close="filterShow=false"></DefaultTournamentFilter>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import DefaultTournamentFilter from "../../bottomSheet/DefaultTournamentFilter";
    export default{
        components: {DefaultTournamentFilter},
        computed: {
          ...mapState('tournaments', ['tournament'])
        },
        data(){
            return{
                filterShow: false,

                selectType: null,
                typeList: [],

                eventList: [],
                selectEvent: null,

                ageList: [],
                selectAge: null,

                levelList: [],
                selectLevel: null
            }
        },
        methods:{
            filterFunc() {
                this.filterShow = true
            },
        },
        created() {
            const type = this.$route.query.typeCode
            const event = this.$route.query.eventCode
            const age = this.$route.query.ageCode
            const level = this.$route.query.levelCode


            const _this = this

            //경기타입
            this.$store.dispatch('filters/getListType', {tnmtId: this.tournament.tnmtId}).then(res => {
                _this.typeList = res.typeList
                if (type) {
                    _this.typeList.filter(item => {
                        if (item.code === type) {
                            _this.selectType = item
                        }
                    })
                }
            }).catch(err => {
                console.dir(err)
            })

            // 세부종목
            if (type) {
                const eventTemp = {
                    "tnmtId": this.tournament.tnmtId,
                    "typeCode": type
                }
                this.$store.dispatch('filters/getListEvent', eventTemp).then(res => {
                    _this.eventList = res.eventList
                    if (event) {
                        _this.eventList.filter(item => {
                            if (item.code === event) {
                                _this.selectEvent = item
                            }
                        })
                    }
                }).catch(err => {
                    console.dir(err)
                })
            }

            //연령
            if (event) {
                const eventTemp = {
                    tnmtId: this.tournament.tnmtId,
                    typeCode: type,
                    eventCode: event
                }

                this.$store.dispatch('filters/getListAge', eventTemp).then(res => {
                    _this.ageList = res.ageList
                    if (age) {
                        _this.ageList.filter(item => {
                            if (item.ageCode === age) {
                                _this.selectAge = item
                            }
                        })
                    }
                }).catch(err => {
                    console.dir(err)
                })
            }

            //구분
            if (age) {
                const levelTemp = {
                    "tnmtId": this.tournament.tnmtId,
                    "typeCode": type,
                    eventCode: event,
                    ageCode: age
                }

                this.$store.dispatch('filters/getListLevel', levelTemp).then(res => {
                    _this.levelList = res.levelList
                    if (level) {
                        _this.levelList.filter(item => {
                            if (item.levelCode === level) {
                                _this.selectLevel = item
                            }
                        })
                    }

                }).catch(() => {
                })
            }
        }
    }
</script>
